// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import { pt } from 'vuetify/locale'
import { mercafacilThemeColors } from '@/config/mercafacilThemeColors'

const mercafacilTheme = {
  colors: mercafacilThemeColors,
}

export default createVuetify({
  locale: {
    locale: 'pt',
    fallback: 'pt',
    messages: {
      pt,
    },
  },
  theme: {
    scope: '#mystique_3',
    stylesheetId: 'vuetify_3-theme-stylesheet',
    defaultTheme: 'mercafacilTheme',
    themes: {
      mercafacilTheme,
    },
  },
  defaults: {
    VSelect: {
      menuProps: {
        attach: '#mystique_3',
        zIndex: 9999,
      },
    },
    VMenu: {
      attach: '#mystique_3',
      zIndex: 9999,
    },
    VOverlay: {
      attach: '#mystique_3',
      zIndex: 9999,
    },
    VDialog: {
      attach: '#mystique_3',
      zIndex: 9999,
      style: {
        boxShadow: 'none',
      },
    },
    VTooltip: {
      attach: '#mystique_3',
      zIndex: 9999,
    },
    VSnackbar: {
      attach: '#mystique_3',
      zIndex: 9999,
    },
  },
})
